import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentAddFilledSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 3a2 2 0 0 0-2 2v20l5-5h15a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm7.5 2.5V10H8v3h4.5v4.5h3V13H20v-3h-4.5V5.5h-3Z"
    />
  </svg>
);
export default IconCommentAddFilledSizeL;
